<template>
    <div class="inner-wrapper add-customer-section">
        <div class="page-title">
            <h1 class="float-left">User Permissions</h1>

        </div>
        <div class="row" v-if="userType == 1 || roleName == 'Admin'">
            <div class="col-md-7">
                <div class="card panel create-box shadow-sm p-3">
                    <div class="view-customer-hed">
                        <div class="view-customer-icon"></div>
                        <span class="view-rght-txt active-txt"></span>
                    </div>
                    <div class="left-blk">
                        <div class="product-details-list">
                            <div class="alert alert-success succ_msg" v-if="successMessage !=null">
                                <strong class="success_msg">{{ successMessage }}</strong>
                            </div>

                            <div class="alert alert-danger succ_msg" v-if="errorMessage !=null">
                                <strong class="success_msg">{{ errorMessage }}</strong>
                            </div>

                            <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                                <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                                <ul>
                                    <li v-for="(v, k) in commonErrors" :key="k">
                                        <p v-for="error in v" :key="error" class="text-sm">
                                            {{ error }}
                                        </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="accordions">

                                <b-button v-b-toggle.collapse-1 variant="primary">Quotation</b-button>
                                <b-collapse id="collapse-1" class="mt-2">
                                    <b-card>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <label class="container-check">
                                                    <input type="checkbox" @change="check($event)" class="role-permission"
                                                           value="add-quotation" :checked="permission.includes('add-quotation')"
                                                           data-role="add-quotation">Add
                                                    <span class="checkmark"></span>
                                                </label>

                                                <label class="container-check">
                                                    <input type="checkbox" @change="check($event)" class="role-permission"
                                                           value="edit-quotation"
                                                           :checked="permission.includes('edit-quotation')"
                                                           data-role="add-quotation">Edit
                                                    <span class="checkmark"></span>
                                                </label>

                                                <label class="container-check">
                                                    <input type="checkbox" @change="check($event)" class="role-permission"
                                                           value="delete-quotation"
                                                           :checked="permission.includes('delete-quotation')"
                                                           data-role="add-quotation">Delete
                                                    <span class="checkmark"></span>
                                                </label>

                                                <label class="container-check">
                                                    <input type="checkbox" @change="check($event)" class="role-permission"
                                                           value="detailview-quotation"
                                                           :checked="permission.includes('detailview-quotation')"
                                                           data-role="add-quotation">View All
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="col-md-12">
                                                <blockquote class="blockquote custom-blockquote blockquote-info rounded mb-0 adm">
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <p class="text-dark mb-1">Users</p>
                                                        <div class="edit-section" v-if="!isEditQuotesOwners">
                                                            <a class="fs-17 text-success" id="adm" href="javascript:void(0)" @click="isEditQuotesOwners=true"><i class="ri-edit-box-line align-middle"></i></a>
                                                        </div>
                                                    </div>
                                                    <footer class="blockquote-footer mt-0 fs-14 fw-medium">
                                                        <span class="quotation-col" v-if="user && user.quotes_owners">
                                                            <template v-for="(owner, index) in user.quotes_owners">
                                                                <template v-if="index>0">, </template>{{owner.owner.name}} <a href="javascript:void(0);" @click="removeShare(owner, 'QUOTE_REPORT')" class="fs-17">X</a>
                                                            </template>
                                                        </span>
                                                    </footer>
                                                </blockquote>

                                                <div class="edit-quote" v-if="isEditQuotesOwners">
                                                    <div class="form-group">
                                                        <select class="form-control" v-model="quotesOwner">
                                                            <option :value="null">Select User for Quotes</option>
                                                            <option v-for="(admin_user, index) in admin_users" :value="admin_user.id">
                                                                {{ admin_user.name }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div class="mt-2">
                                                        <a href="javascript:void(0);" @click="saveOwner('QUOTE_REPORT')" class="btn-primary">Save</a>
                                                        <a href="javascript:void(0);" @click="isEditQuotesOwners=false" class="btn-danger">Close</a>
                                                    </div>
                                                </div>
                                                <!--<div class="form-group">
                                                    <select class="form-control" multiple="true" v-model="quotesOwners" @change="saveShare($event, 'QUOTE_REPORT')">
                                                        <option :value="null">Select Users for Quotes</option>
                                                        <option v-for="(admin_user, index) in admin_users" :value="admin_user.id">
                                                            {{ admin_user.name }}
                                                        </option>
                                                    </select>
                                                </div>-->
                                            </div>
                                        </div>

                                    </b-card>
                                </b-collapse>
                            </div>

                            <div class="accordion-item">
                                <b-button v-b-toggle.collapse-12 variant="primary">Sales Order</b-button>
                                <b-collapse id="collapse-12" class="mt-2">
                                    <b-card>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <label class="container-check">
                                                    <input @change="check($event)" type="checkbox" class="role-permission"
                                                           value="add-sales-order" :checked="permission.includes('add-sales-order')"
                                                           data-role="add-sales-order">Add
                                                    <span class="checkmark"></span>
                                                </label>

                                                <label class="container-check">
                                                    <input @change="check($event)" type="checkbox" class="role-permission"
                                                           value="edit-sales-order" :checked="permission.includes('edit-sales-order')"
                                                           data-role="add-sales-order">Edit
                                                    <span class="checkmark"></span>
                                                </label>

                                                <label class="container-check">
                                                    <input @change="check($event)" type="checkbox" class="role-permission"
                                                           value="delete-sales-order"
                                                           :checked="permission.includes('delete-sales-order')"
                                                           data-role="add-sales-order">Delete
                                                    <span class="checkmark"></span>
                                                </label>

                                                <label class="container-check">
                                                    <input type="checkbox" @change="check($event)" class="role-permission"
                                                           value="view-all-sales-order"
                                                           :checked="permission.includes('view-all-sales-order')"
                                                           data-role="view-all-sales-order">View All
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="col-md-12">
                                                <blockquote class="blockquote custom-blockquote blockquote-info rounded mb-0 adm">
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <p class="text-dark mb-1">Users</p>
                                                        <div class="edit-section" v-if="!isEditSoOwners">
                                                            <a class="fs-17 text-success" id="isEditSoOwners" href="javascript:void(0)" @click="isEditSoOwners=true"><i class="ri-edit-box-line align-middle"></i></a>
                                                        </div>
                                                    </div>
                                                    <footer class="blockquote-footer mt-0 fs-14 fw-medium">
                                                        <span class="quotation-col" v-if="user && user.so_owners">
                                                            <template v-for="(owner, index) in user.so_owners">
                                                                <template v-if="index>0">, </template>{{owner.owner.name}} <a href="javascript:void(0);" @click="removeShare(owner, 'SO_REPORT')" class="fs-17">X</a>
                                                            </template>
                                                        </span>
                                                    </footer>
                                                </blockquote>

                                                <div class="edit-quote" v-if="isEditSoOwners">
                                                    <div class="form-group">
                                                        <select class="form-control" v-model="soOwner">
                                                            <option :value="null">Select User for SO</option>
                                                            <option v-for="(admin_user, index) in admin_users" :value="admin_user.id">
                                                                {{ admin_user.name }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div class="mt-2">
                                                        <a href="javascript:void(0);" @click="saveOwner('SO_REPORT')" class="btn-primary">Save</a>
                                                        <a href="javascript:void(0);" @click="isEditSoOwners=false" class="btn-danger">Close</a>
                                                    </div>
                                                </div>
                                                <!--<div class="form-group">
                                                    <select class="form-control" multiple="true" v-model="soOwners" @change="saveShare($event, 'SO_REPORT')">
                                                        <option :value="null">Select Users for SO</option>
                                                        <option v-for="(admin_user, index) in admin_users" :value="admin_user.id">
                                                            {{ admin_user.name }}
                                                        </option>
                                                    </select>
                                                </div>-->
                                            </div>
                                        </div>
                                    </b-card>
                                </b-collapse>
                            </div>

                            <div class="accordion-item">
                                <b-button v-b-toggle.collapse-13 variant="primary">Purchase Order</b-button>
                                <b-collapse id="collapse-13" class="mt-2">
                                    <b-card>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <label class="container-check">
                                                    <input @change="check($event)" type="checkbox" class="role-permission"
                                                           value="add-purchase-order" :checked="permission.includes('add-purchase-order')"
                                                           data-role="add-purchase-order">Add
                                                    <span class="checkmark"></span>
                                                </label>

                                                <label class="container-check">
                                                    <input @change="check($event)" type="checkbox" class="role-permission"
                                                           value="edit-purchase-order" :checked="permission.includes('edit-purchase-order')"
                                                           data-role="add-purchase-order">Edit
                                                    <span class="checkmark"></span>
                                                </label>

                                                <label class="container-check">
                                                    <input @change="check($event)" type="checkbox" class="role-permission"
                                                           value="delete-purchase-order"
                                                           :checked="permission.includes('delete-purchase-order')"
                                                           data-role="add-purchase-order">Delete
                                                    <span class="checkmark"></span>
                                                </label>

                                                <label class="container-check">
                                                    <input type="checkbox" @change="check($event)" class="role-permission"
                                                           value="view-all-purchase-order"
                                                           :checked="permission.includes('view-all-purchase-order')"
                                                           data-role="view-all-purchase-order">View All
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="col-md-12">
                                                <blockquote class="blockquote custom-blockquote blockquote-info rounded mb-0 adm">
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <p class="text-dark mb-1">Users</p>
                                                        <div class="edit-section" v-if="!isEditPoOwners">
                                                            <a class="fs-17 text-success" id="isEditPoOwners" href="javascript:void(0)" @click="isEditPoOwners=true"><i class="ri-edit-box-line align-middle"></i></a>
                                                        </div>
                                                    </div>
                                                    <footer class="blockquote-footer mt-0 fs-14 fw-medium">
                                                        <span class="quotation-col" v-if="user && user.po_owners">
                                                            <template v-for="(owner, index) in user.po_owners">
                                                                <template v-if="index>0">, </template>{{owner.owner.name}} <a href="javascript:void(0);" @click="removeShare(owner, 'PO_REPORT')" class="fs-17">X</a>
                                                            </template>
                                                        </span>
                                                    </footer>
                                                </blockquote>

                                                <div class="edit-quote" v-if="isEditPoOwners">
                                                    <div class="form-group">
                                                        <select class="form-control" v-model="poOwner">
                                                            <option :value="null">Select User for PO</option>
                                                            <option v-for="(admin_user, index) in admin_users" :value="admin_user.id">
                                                                {{ admin_user.name }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div class="mt-2">
                                                        <a href="javascript:void(0);" @click="saveOwner('PO_REPORT')" class="btn-primary">Save</a>
                                                        <a href="javascript:void(0);" @click="isEditPoOwners=false" class="btn-danger">Close</a>
                                                    </div>
                                                </div>
                                                <!--<div class="form-group">
                                                    <select class="form-control" multiple="true" v-model="poOwners" @change="saveShare($event, 'PO_REPORT')">
                                                        <option :value="null">Select Users for PO</option>
                                                        <option v-for="(admin_user, index) in admin_users" :value="admin_user.id">
                                                            {{ admin_user.name }}
                                                        </option>
                                                    </select>
                                                </div>-->
                                            </div>
                                        </div>
                                    </b-card>
                                </b-collapse>
                            </div>

                            <div class="accordion-item">
                                <b-button v-b-toggle.collapse-2 variant="primary">Customer</b-button>
                                <b-collapse id="collapse-2" class="mt-2">
                                    <b-card>
                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="add-customer" :checked="permission.includes('add-customer')"
                                                   data-role="add-quotation">Add
                                            <span class="checkmark"></span>
                                        </label>

                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="edit-customer" :checked="permission.includes('edit-customer')"
                                                   data-role="add-quotation">Edit
                                            <span class="checkmark"></span>
                                        </label>

                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="delete-customer"
                                                   :checked="permission.includes('delete-customer')"
                                                   data-role="add-quotation">Delete
                                            <span class="checkmark"></span>
                                        </label>
                                    </b-card>
                                </b-collapse>
                            </div>

                            <div class="accordion-item">
                                <b-button v-b-toggle.collapse-10 variant="primary">Vendor</b-button>
                                <b-collapse id="collapse-10" class="mt-2">
                                    <b-card>
                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="add-vendor" :checked="permission.includes('add-vendor')"
                                                   data-role="add-quotation">Add
                                            <span class="checkmark"></span>
                                        </label>

                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="edit-vendor" :checked="permission.includes('edit-vendor')"
                                                   data-role="add-quotation">Edit
                                            <span class="checkmark"></span>
                                        </label>

                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="delete-vendor" :checked="permission.includes('delete-vendor')"
                                                   data-role="add-quotation">Delete
                                            <span class="checkmark"></span>
                                        </label>
                                    </b-card>
                                </b-collapse>
                            </div>

                            <div class="accordion-item">
                                <b-button v-b-toggle.collapse-3 variant="primary">Task</b-button>
                                <b-collapse id="collapse-3" class="mt-2">
                                    <b-card>
                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="add-task" :checked="permission.includes('add-task')"
                                                   data-role="add-quotation">Add
                                            <span class="checkmark"></span>
                                        </label>

                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="edit-task" :checked="permission.includes('edit-task')"
                                                   data-role="add-quotation">Edit
                                            <span class="checkmark"></span>
                                        </label>

                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="detail-task" :checked="permission.includes('detail-task')"
                                                   data-role="add-quotation">Detail View
                                            <span class="checkmark"></span>
                                        </label>
                                    </b-card>
                                </b-collapse>
                            </div>

                            <div class="accordion-item">
                                <b-button v-b-toggle.collapse-4 variant="primary">Task Priority</b-button>
                                <b-collapse id="collapse-4" class="mt-2">
                                    <b-card>
                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="add-taskpriority"
                                                   :checked="permission.includes('add-taskpriority')"
                                                   data-role="add-quotation">Add
                                            <span class="checkmark"></span>
                                        </label>

                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="edit-taskpriority"
                                                   :checked="permission.includes('edit-taskpriority')"
                                                   data-role="add-quotation">Edit
                                            <span class="checkmark"></span>
                                        </label>

                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="delete-taskpriority"
                                                   :checked="permission.includes('delete-taskpriority')"
                                                   data-role="add-quotation">Delete
                                            <span class="checkmark"></span>
                                        </label>
                                    </b-card>
                                </b-collapse>
                            </div>


                            <div class="accordion-item">
                                <b-button v-b-toggle.collapse-6 variant="primary">User Role</b-button>
                                <b-collapse id="collapse-6" class="mt-2">
                                    <b-card>
                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="add-role" :checked="permission.includes('add-role')"
                                                   data-role="add-quotation">Add
                                            <span class="checkmark"></span>
                                        </label>

                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="edit-role" :checked="permission.includes('edit-role')"
                                                   data-role="add-quotation">Edit
                                            <span class="checkmark"></span>
                                        </label>

                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="delete-role" :checked="permission.includes('delete-role')"
                                                   data-role="add-quotation">Delete
                                            <span class="checkmark"></span>
                                        </label>
                                    </b-card>
                                </b-collapse>
                            </div>

                            <div class="accordion-item">
                                <b-button v-b-toggle.collapse-7 variant="primary">Quotation Status</b-button>
                                <b-collapse id="collapse-7" class="mt-2">
                                    <b-card>
                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="add-quotationstatus"
                                                   :checked="permission.includes('add-quotationstatus')"
                                                   data-role="add-quotation">Add
                                            <span class="checkmark"></span>
                                        </label>

                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="edit-quotationstatus"
                                                   :checked="permission.includes('edit-quotationstatus')"
                                                   data-role="add-quotation">Edit
                                            <span class="checkmark"></span>
                                        </label>

                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="delete-quotationstatus"
                                                   :checked="permission.includes('delete-quotationstatus')"
                                                   data-role="add-quotation">Delete
                                            <span class="checkmark"></span>
                                        </label>
                                    </b-card>
                                </b-collapse>
                            </div>

                            <div class="accordion-item">
                                <b-button v-b-toggle.collapse-8 variant="primary">Vendor Bag</b-button>
                                <b-collapse id="collapse-8" class="mt-2">
                                    <b-card>
                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="add-vendorbag" :checked="permission.includes('add-vendorbag')"
                                                   data-role="add-quotation">Add
                                            <span class="checkmark"></span>
                                        </label>

                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="edit-vendorbag"
                                                   :checked="permission.includes('edit-vendorbag')"
                                                   data-role="add-quotation">Edit
                                            <span class="checkmark"></span>
                                        </label>

                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="delete-vendorbag"
                                                   :checked="permission.includes('delete-vendorbag')"
                                                   data-role="add-quotation">Delete
                                            <span class="checkmark"></span>
                                        </label>
                                    </b-card>
                                </b-collapse>
                            </div>
                            <div class="accordion-item">
                                <b-button v-b-toggle.collapse-14 variant="primary">Reports</b-button>
                                <b-collapse id="collapse-14" class="mt-2">
                                    <b-card>
                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="view-all-sales-order-report" :checked="permission.includes('view-all-sales-order-report')"
                                                   data-role="view-all-sales-order-report">View
                                            <span class="checkmark"></span>
                                        </label>

                                        <label class="container-check">
                                            <!--<input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="view-all-purchase-order-report" :checked="permission.includes('view-all-purchase-order-report')"
                                                   data-role="view-all-purchase-order-report">See purchase orders
                                            <span class="checkmark"></span>-->
                                        </label>

                                        <label class="container-check">

                                        </label>

                                        <label class="container-check">

                                        </label>
                                    </b-card>
                                </b-collapse>
                            </div>

                            <div class="accordion-item">
                                <b-button v-b-toggle.collapse-9 variant="primary">Shipping</b-button>
                                <b-collapse id="collapse-9" class="mt-2">
                                    <b-card>
                                        

                                        <label class="container-check">
                                            <input @change="check($event)" type="checkbox" class="role-permission"
                                                   value="edit-shipping"
                                                   :checked="permission.includes('edit-shipping')"
                                                   data-role="add-quotation">Edit
                                            <span class="checkmark"></span>
                                        </label>

                                        
                                    </b-card>
                                </b-collapse>
                            </div>



                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            You are not authorized to view 'User Permissions'
        </div>

    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import ProductDetail from "../../components/ProductDetails";

export default {
    name: "UserPermission",
    components: {
        ProductDetail
    },
    created() {
        this.getPermissions();
    },
    data() {
        return {
            permission: [],
            customerData: {
                customer: null,
                country_data: null,
                customer_contact: null,
                can_add_customer: false,
                can_edit_customer: false,
                can_delete_customer: false,
                user_type: null,
                role: null
            },
            admin_users: [],
            quotesOwners: [],
            soOwners: [],
            poOwners: [],
            quotesOwner: null,
            soOwner: null,
            poOwner: null,
            user: null,
            isEditSoOwners: false,
            isEditPoOwners: false,
            isEditQuotesOwners: false
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        check(event) {
            if (event.target.checked) {
                let roleName = event.target.value;
                let self = this;
                this.setCustomerLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.post(window.route('users.assignPermission', {id: this.$route.params.id}), {role_name: roleName}, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({data}) => {
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        } else if (data.errorMessage) {
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.setSuccessMessage(data.data);
                            setTimeout(() => {
                                self.setSuccessMessage(null);
                            }, 3500);
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setCustomerLoading(false);

                    });
            } else {
                let roleName = event.target.value;
                let self = this;
                this.setCustomerLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.post(window.route('users.removePermission', {id: this.$route.params.id}), {role_name: roleName}, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({data}) => {
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        } else if (data.errorMessage) {
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.setSuccessMessage(data.data);
                            setTimeout(() => {
                                self.setSuccessMessage(null);
                            }, 3500);
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setCustomerLoading(false);

                    });
            }
        },
        removeShare(owner, type) {
            let owners = [];
            if(type == 'SO_REPORT') {
                owners = this.soOwners.filter((x) => x != owner.owner_id);
            } else if(type == 'PO_REPORT') {
                owners = this.poOwners.filter((x) => x != owner.owner_id);
            } else {
                owners = this.quotesOwners.filter((x) => x != owner.owner_id);
            }
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('users.resourceShare', {id: this.$route.params.id, type: type}), {owners: owners, multiple: true}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        self.setSuccessMessage(data.data);
                        this.getPermissions();
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 3500);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        saveOwner(type) {
            let owner = null;
            if(type == 'SO_REPORT') {
                owner = this.soOwner;
            } else if(type == 'PO_REPORT') {
                owner = this.poOwner;
            } else {
                owner = this.quotesOwner;
            }
            if(!owner) {
                return false;
            }
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('users.resourceShare', {id: this.$route.params.id, type: type}), {owner: owner, multiple: false}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        self.setSuccessMessage(data.data);
                        if(type == 'SO_REPORT') {
                            this.soOwner = null;
                            this.isEditSoOwners = false;
                        } else if(type == 'PO_REPORT') {
                            this.poOwner = null;
                            this.isEditPoOwners = false;
                        } else {
                            this.quotesOwner = null;
                            this.isEditQuotesOwners = false;
                        }
                        this.getPermissions();
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 3500);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        saveShare(event, type) {
            //console.log(event.target.value, this.soOwners, this.poOwners);
            let owners = [];
            if(type == 'SO_REPORT') {
                owners = this.soOwners;
            } else if(type == 'PO_REPORT') {
                owners = this.poOwners;
            } else {
                owners = this.quotesOwners;
            }
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('users.resourceShare', {id: this.$route.params.id, type: type}), {owners: owners, multiple: true}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        self.setSuccessMessage(data.data);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 3500);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getPermissions() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('users.permission', {id: this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.permission = data.data;
                        this.admin_users = data.admins;

                        this.user = data.user;

                        this.soOwners = [];
                        if(data.soOwners) {
                            data.soOwners.forEach((item) => {
                                this.soOwners.push(item.owner_id);
                            });
                        }
                        this.poOwners = [];
                        if(data.poOwners) {
                            data.poOwners.forEach((item) => {
                                this.poOwners.push(item.owner_id);
                            });
                        }

                        this.quotesOwners = [];
                        if(data.quotesOwners) {
                            data.quotesOwners.forEach((item) => {
                                this.quotesOwners.push(item.owner_id);
                            });
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getSLNo(index) {
            return Number(this.customerData.config['start_from']) + index;
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading',
            'getAuthUserRoleName',
            'getAuthUserPermissions'
        ]),
        authUser(){
            return this.getAuthUser;
        },
        userType() {
            return this.getAuthUser ? this.getAuthUser.user_type : null;
        },
        roleName() {
            return this.getAuthUserRoleName;
        },
        permissions() {
            return this.getAuthUserPermissions;
        },
    },
    watch: {
        /*soOwners: {
            handler: function (after, before) {
                if(after != null) {
                    this.saveShare('SO_REPORT', after);
                }

            },
            deep: true,
        },
        poOwners: {
            handler: function (after, before) {
                if(after != null) {
                    this.saveShare('PO_REPORT', after);
                }

            },
            deep: true,
        },*/
    }
}
</script>

<style scoped>

</style>
